import React from "react";
import { CircleCheckIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { personaItems } from "../data/landing";
export function PersonaSection() {
  return <section className="bg-white" data-id="element-209" data-mp="7xdivhtsht1l">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-24" data-id="element-210" data-mp="7yevvrud8ply">
        <SectionHeading eyebrow="Is This Right for Your Family?" title="This Collection Is for You If…" data-id="element-211" data-mp="cvyknloowks5" />

        <ol className="mt-10 space-y-3" data-id="element-212" data-mp="10l9ioveno12l">
          {personaItems.map((item, i) => <li key={item} className="flex items-start gap-4 rounded-2xl bg-canvas p-5 md:p-6" data-id="element-213" data-mp="14ne6vemc45hu" data-mpi={i}>
              <CircleCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-leaf" strokeWidth={2.25} aria-hidden="true" data-id="element-214" data-mp="14l1pb2khnx5b" />
              <div data-id="element-215" data-mp="vmg22u42nty7">
                <span className="font-display text-xs font-extrabold tracking-wider text-gold-deep" data-id="element-216" data-mp="vlwrjygr47u7">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="mt-0.5 text-[17px] leading-relaxed text-ink" data-id="element-217" data-mp="3gcnlqs5i72af">{item}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-xl font-bold leading-snug text-navy" data-id="element-218" data-mp="1sm39pengtvis">
          If you've ever wondered whether your child truly understands WHY they believe, this collection gives your
          family a place to begin.
        </p>
      </div>
    </section>;
}